import { FunctionComponent } from 'react';

import { FormProps, Form as KendoForm } from '@progress/kendo-react-form';

export const Form: FunctionComponent<FormProps> = ({ ...props }) => (
  <KendoForm {...props} />
);

Form.displayName = 'Form';
